import loadable from '@loadable/component'

export const LazyTheWestTermsContent = loadable(() =>
    import('./TheWestTermsContent'),
)
